export default {
    dealers_main_id: 'Id',
    dealers_main_name: 'Name',
    dealers_main_email: 'Email',
    dealers_main_username: 'Username',
    dealers_main_companies: 'Companies',
    dealers_main_dealers: 'Dealers',
    dealers_main_master_company_name: 'Master Company',
    dealers_main_apply: 'Apply',
    dealers_main_tags: 'Tags',
    dealers_main_active_dealers_only: 'Active Accounts Only',
    dealers_main_yes: 'Yes',
    dealers_main_no: 'No',
    dealers_main_authenticate_cloud: 'Login as Customer',
    dealers_main_re_sync_backend_information: 'Re-sync Backend Information',
    dealers_main_devices: 'Devices',
    dealers_main_package: 'Package',
    dealers_main_crm: 'Salesforce Id',
    dealers_main_add_dealer: 'Add Dealer',
    dealers_main_edit: 'Edit',
    dealers_main_remove_filters: 'Remove filters',
    dealers_main_account_details: 'Account Details',
    dealers_main_import_from_p4: 'Import From P4',
    dealers_main_reprocess_odo_hours: 'Reprocess Odo/Hrs',
    dealers_main_new_status: 'New Status',
    dealers_main_at: 'at',
    dealers_main_next_scheduled_action: 'Next scheduled action on',
    dealers_main_on: 'on',
    dealers_main_brand: 'Brand',
};



